import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {push} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {FormattedMessage} from 'react-intl';
import * as actionCreators from '../actions';
import Drawer from 'material-ui/Drawer'
import AppBar from 'material-ui/AppBar';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import TreeList from '../components/TreeList'
import ListItemContent from '../components/ListItemContent';
import RightTopMenu from '../components/RightTopMenu';
import injectTapEventPlugin from 'react-tap-event-plugin';
import EventListener from 'react-event-listener';
import CenteredSpinner from '../components/CenteredSpinner';
import BreadCrumbs from '../components/BreadCrumbs';

injectTapEventPlugin();

class BookView extends Component {
   constructor(props) {
      super(props);

      let dDocked = true;
      let dOpen = true;
      let cMarginLeft = 420;
      const width = window.innerWidth;
      if (width < 1280) {
         dDocked = false;
         dOpen = false;
         cMarginLeft = 20;
      }

      this.state = {
         searchTerm: '',
         expandedListItems: [],
         drawerDocked: dDocked,
         drawerOpen: dOpen,
         contentMarginLeft: cMarginLeft
      };

      this.handleSearch = this.handleSearch.bind(this);
      this.handleTouchTap = this.handleTouchTap.bind(this);
      this.handleMoveToPrev = this.handleMoveToPrev.bind(this);
      this.handleMoveToNext = this.handleMoveToNext.bind(this);
      this.handleDrawerTitleClick = this.handleDrawerTitleClick.bind(this);
      this.handleMenuIconClick = this.handleMenuIconClick.bind(this);
      this.handleWindowResize = this.handleWindowResize.bind(this);
   }

   handleSearch(searchTerm) {
      this.setState({searchTerm})
   }

   handleTouchTap(listItem, index) {
      const {expandedListItems} = this.state;
      if (listItem.children) {
         const indexOfListItemInArray = expandedListItems.indexOf(index);
         if  (indexOfListItemInArray === -1) {
            this.setState({
               expandedListItems: expandedListItems.concat([index])
            })
         } else {
            let newArray = [].concat(expandedListItems);
            newArray.splice(indexOfListItemInArray, 1);
            this.setState({
               expandedListItems: newArray
            })
         }
      }
   }

   handleMoveToPrev() {
      const {currentArticleKey, listItemKeyToIndexMap, files, listItems, match, dispatch} = this.props;
      const activeListItem = listItemKeyToIndexMap[currentArticleKey];
      const index = files.indexOf(activeListItem);
      const nextActiveListItem = files[index - 1];
      if (index !== 0) {
         const bookKey = match.params.bookKey;
         const articleKey = listItems[nextActiveListItem].articleKey;
         dispatch(push(`/book/${bookKey}/article/${articleKey}`));
      }
   }

   handleMoveToNext() {
      const {currentArticleKey, listItemKeyToIndexMap, files, listItems, match, dispatch} = this.props;
      const activeListItem = listItemKeyToIndexMap[currentArticleKey];
      const index = files.indexOf(activeListItem);
      const nextActiveListItem = files[index + 1];
      if (index !== files.length - 1) {
         const bookKey = match.params.bookKey;
         const articleKey = listItems[nextActiveListItem].articleKey;
         dispatch(push(`/book/${bookKey}/article/${articleKey}`));
      }
   }

   handleMenuIconClick(e) {
      this.setState({drawerOpen: !this.state.drawerOpen});
   }

   handleDrawerTitleClick(e) {
      const {dispatch} = this.props;
      dispatch(push('/'));
   }

   handleWindowResize(e) {
      const width = e.target.innerWidth;
      const {drawerDocked} = this.state;
      if (width > 1279) {
         if (!drawerDocked) {
            this.setState({
               drawerDocked: true,
               drawerOpen: true,
               contentMarginLeft: 420
            });
         }
      } else {
         if (drawerDocked) {
            this.setState({
               drawerDocked: false,
               drawerOpen: false,
               contentMarginLeft: 20
            });
         }
      }
   }

   componentDidMount() {
      const {token, currentBookKey, currentArticleKey, listItems, listItemKeyToIndexMap, actions, match} = this.props;
      const bookKeyFromUrl = match.params.bookKey;
      const articleKeyFromUrl = match.params.articleKey;

      const keyRegexp = /^c\d+a\d+t\d+r\d+/ig;
      const bookKeyFailed = !!bookKeyFromUrl && bookKeyFromUrl.search(keyRegexp) === -1;
      const articleKeyFailed = !!articleKeyFromUrl && articleKeyFromUrl.search(keyRegexp) === -1;
      if (bookKeyFailed || articleKeyFailed){
         this._redirectToPageNotFound();
      }

      if (!currentBookKey || bookKeyFromUrl !== currentBookKey){
         actions.fetchBookData(token, bookKeyFromUrl, articleKeyFromUrl);
      } else {
         const activeListItem = listItemKeyToIndexMap[currentArticleKey];
         if (!!activeListItem) {
            let parents = [];
            const listItem = listItems[activeListItem];
            if (!!listItem.children) {
               parents.push(activeListItem);
            }
            const expandedListItems = this._getAllParents(listItems[activeListItem], listItems, parents);
            this.setState({
               expandedListItems: expandedListItems
            });
         } else {
            this._redirectToPageNotFound();
         }
      }

      const drawerContainer = this._getDrawerContainer();
      drawerContainer.addEventListener('scroll', this._handleDrawerContainerScroll);
   }

   _redirectToPageNotFound() {
      const {location, dispatch} = this.props;
      const currentLocation = location.pathname;
      dispatch(push({
         pathname: '/pageNotFound',
         state: { referrer: currentLocation }
      }));
   }

   componentWillUnmount() {
      const {actions, match} = this.props;
      const bookKeyFromUrl = match.params.bookKey;
      const drawerContainer = this._getDrawerContainer();
      actions.setDrawerContainerScrollParams(bookKeyFromUrl, drawerContainer.drawerContainerScrollTop);
      drawerContainer.removeEventListener('scroll', this._handleDrawerContainerScroll);
   }

   _handleDrawerContainerScroll(e) {
      e.target.drawerContainerScrollTop = e.target.scrollTop;
   }

   _getDrawerContainer() {
      const drawerDiv = ReactDOM.findDOMNode(this.refs.drawerControl);
      if (!!drawerDiv) {
         return drawerDiv.lastChild;
      }

      return null;
   }

   componentDidUpdate(prevProps, prevState) {
      const {currentArticleKey, listItemKeyToIndexMap, listItems, isBookDataFetching,
               drawerContainerScrollParams, match, dispatch, actions} = this.props;
      let articleKeyFromUrl = match.params.articleKey;
      if (!articleKeyFromUrl) {
         if (!isBookDataFetching && !!listItemKeyToIndexMap) {
            let firstArticleKey = Object.keys(listItemKeyToIndexMap)[0];
            dispatch(push(`${match.url}/article/${firstArticleKey}`));
            actions.setCurrentArticleKey(firstArticleKey);
         }
      } else {
         if (!!listItemKeyToIndexMap) {
            if (articleKeyFromUrl !== currentArticleKey) {
               actions.setCurrentArticleKey(articleKeyFromUrl);
            } else if (currentArticleKey !== prevProps.currentArticleKey) {
               const activeListItem = listItemKeyToIndexMap[currentArticleKey];
               if (!!activeListItem) {
                  let parents = [];
                  const listItem = listItems[activeListItem];
                  if (!!listItem.children) {
                     parents.push(activeListItem);
                  }
                  const expandedListItems = this._getAllParents(listItem, listItems, parents);
                  this.setState({
                     expandedListItems: expandedListItems
                  });

                  // установка скролла в предыдущее до обновления положение
                  const bookKeyFromUrl = match.params.bookKey;
                  if (!!drawerContainerScrollParams && drawerContainerScrollParams.bookKey === bookKeyFromUrl){
                     const drawerContainer = this._getDrawerContainer();
                     drawerContainer.scrollTop = drawerContainerScrollParams.scrollTop;
                  }
               } else {
                  this._redirectToPageNotFound();
               }
            }
         }
      }
   }

   render() {
      const {searchTerm, expandedListItems, drawerOpen, drawerDocked, contentMarginLeft} = this.state;
      const {listItems, listItemKeyToIndexMap, currentArticleKey, isBookDataFetching, match} = this.props;
      let activeListItem;
      if (!!listItemKeyToIndexMap){
         activeListItem = listItemKeyToIndexMap[currentArticleKey];
      }
      const icons = {
         leftIconCollapsed: <i style={{height: 16, width: 16, color: '#CCCCCC'}} className="fa fa-caret-right"/>,
         leftIconExpanded: <i style={{height: 16, width: 16, color: '#CCCCCC'}} className="fa fa-caret-down"/>
      };
      const bookKeyFromUrl = match.params.bookKey;
      return (
         <div>
            {!!bookKeyFromUrl ?
               <div>
                  <EventListener
                     target="window"
                     onResize={this.handleWindowResize}
                  />
                  <Drawer
                     ref="drawerControl"
                     containerClassName="drawer-scroll-container"
                     open={drawerOpen}
                     width={400}
                     docked={drawerDocked}
                     onRequestChange={(drawerOpen) => this.setState({drawerOpen})}>
                     <AppBar
                        title={<div><div className="CrawlerLink"><a href="/">Home</a></div><FormattedMessage id="bookView.appBar.title" defaultMessage="Home" /></div>}
                        iconElementLeft={<IconButton
                           onTouchTap={this.handleDrawerTitleClick}><NavigationArrowBack /></IconButton>}
                     />
                     {isBookDataFetching === false && !!listItems && !!activeListItem
                        ? <TreeList
                           listItems={listItems}
                           listItemKeyToIndexMap={listItemKeyToIndexMap}
                           contentKey={'title'}
                           bookKey={bookKeyFromUrl}
                           useFolderIcons={true}
                           haveSearchbar={true}
                           expandedListItems={expandedListItems}
                           activeListItem={activeListItem}
                           handleTouchTap={this.handleTouchTap}
                           handleSearch={this.handleSearch}
                           searchTerm={searchTerm}
                           icons={icons}
                        >
                        </TreeList> :
                        <CenteredSpinner />
                     }
                  </Drawer>
                  <div>
                     <AppBar
                        title={<FormattedMessage id="bookView.appBar.menu" defaultMessage="Menu" />}
                        onLeftIconButtonTouchTap={this.handleMenuIconClick}
                        iconElementRight={<RightTopMenu/>}
                     />
                     <div style={{minHeight: 400, margin: '20px', marginLeft: contentMarginLeft}}>
                        {isBookDataFetching === false && !!listItems && !!activeListItem
                           ? <div>
                              <ListItemContent title={<BreadCrumbs listItems={listItems} expandedListItems={expandedListItems} activeListItem={activeListItem}/>}/>
                              < div style={{marginTop: 20, marginBottom: 20, textAlign: 'center'}}>
                                 <RaisedButton
                                    label={<FormattedMessage id="bookView.listContent.prevBtn" defaultMessage="Previous" />}
                                    secondary={true}
                                    style={{marginRight: 10}}
                                    onClick={this.handleMoveToPrev}/>
                                 <RaisedButton
                                    label={<FormattedMessage id="bookView.listContent.nextBtn" defaultMessage="Next" />}
                                    secondary={true}
                                    onClick={this.handleMoveToNext}/>
                              </div>
                           </div> :
                           ''
                        }
                     </div>
                  </div>
               </div> : ''
            }
         </div>
      );
   }

   _getAllParents(listItem, listItems, parents = []) {
      if (listItem.parentIndex) {
         return this._getAllParents(listItems[listItem.parentIndex], listItems, parents.concat([listItem.parentIndex]));
      } else {
         return parents;
      }
   }
}

const mapStateProps = (state) => ({
   currentBookKey: state.data.currentBookKey,
   currentArticleKey: state.data.currentArticleKey,
   files: state.data.listLeafs,
   listItemKeyToIndexMap: state.data.listLeafKeyToIndexMap,
   listItems: state.data.bookData,
   isBookDataFetching: state.data.isBookDataFetching,
   drawerContainerScrollParams: state.ctrl.drawerContainerScrollParams
});

const mapDispatchToProps = (dispatch) => ({
   actions: bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateProps, mapDispatchToProps)(BookView);



// WEBPACK FOOTER //
// ./src/views/BookView.js